var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"page-title"},[_vm._v("관리자 계정정보 수정")]),_c('edit-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }